<template>
  <v-dialog max-width="500" :value="dialog" @click:outside="close">
    <v-card class="align-center d-flex flex-column py-10 px-7">
      <CloseDialogButton :close="close" />
      <div class="font-size-lg font-weight-semibold mb-5">
        Edit Email Address
      </div>
      <v-form ref="form" v-model="valid" class="full-width">
        <EmailInput :email="wait(user, 'email')" :update="update" />
        <v-btn
          color="success"
          :disabled="!valid"
          @click.prevent="saveEmail"
          block
          large
          rounded
        >
          <div class="font-size-md font-weight-semibold text-capitalize">
            save
          </div>
        </v-btn>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { wait } from "@/util.js";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import EmailInput from "@/components/Inputs/Email.vue";

export default {
  name: "EditEmailDialog",
  components: { CloseDialogButton, EmailInput },
  computed: {
    ...mapState({
      user: (state) => state.user.info,
    }),
  },
  data() {
    return {
      /*
      confirmEmail: null,
      confirmPassword: null,
      */
      email: null,
      valid: true,
    };
  },
  methods: {
    saveEmail() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.email && this.save({ email: this.email });
      this.close();
    },
    update(name, val) {
      this[name] = val;
    },
    wait,
  },
  props: {
    close: Function,
    dialog: Boolean,
    save: Function,
  },
};
</script>
